import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { SelectMemberBlade } from './SelectMemberBlade';
import { Stack, Typography } from '@ace-clublabs/shared-component-library';

export interface ISelectMemberBladeListProps {
  onSelectClick: any;
  selectedMemberIndex: number;
  orderedMemberItems: {
    memberName: string;
    memberRole: RoleType;
    customerId: string | undefined;
  }[];
}
export const SelectMemberBladeList = ({
  onSelectClick,
  selectedMemberIndex,
  orderedMemberItems,
}: ISelectMemberBladeListProps) => {
  const handleClick = (index: number) => {
    onSelectClick(index);
  };
  return (
    <Stack direction="column" gap="8px" sx={{ paddingTop: '1.5rem' }} className="select-member-blade-list">
      <Typography variant="b1Regular">Select a member to view more details</Typography>
      {orderedMemberItems?.map((member, i) => (
        <SelectMemberBlade
          className={`members-detail-selector-${i}`}
          memberName={member.memberName}
          memberRole={member.memberRole}
          key={`member-blade-item-${i}`}
          onClick={() => handleClick(i)}
          selected={selectedMemberIndex === i}
        />
      ))}
    </Stack>
  );
};
